import {throwToast} from './helpers';

class SchoolBooks extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.results = this.querySelector('#results');
    this.template = this.querySelector('#product-result');
    this.selectTemplate = this.querySelector('#value-select');
    this.loader = this.querySelector('.loader');
  }

  connectedCallback() {
    this.getSchools();
    this.select.addEventListener('change', (event) => {
      this.getProducts(event);
    });
  }

  getSchools = () => {
    const url = '/apps/wb/api/getSchools';

      fetch(url).then((response) => {
        if(response.ok) {
          return response.json();
        }
        throw new Error('Sorry - we encountered an error getting schools - please reload the page and try again');
      })
      .then((data) => {
        data.forEach(school => {
          const option = document.createElement('option');
          option.value = school.id;
          option.innerText = school.name;
          this.select.appendChild(option);
        });
      })
      .catch((error) => {
        this.results.textContent = error;
      });

  };

  getProducts = (event) => {
    this.results.textContent = '';
    this.loader.style.display = 'block';
    const postConfig = (data) => {
      return {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
      };
    };
    const postData = postConfig({school: event.target.value});
    const url = '/apps/wb/api/getProducts';
    fetch(url, postData).then((response) => {
      if (response.ok) {
        return response.json();
      }
      throw new Error(`Sorry - we had a problem fetching this school's books - please reload your page and try again.`);
    }).then((data) => {

      if (!data.length) {
        this.results.innerHTML = `<h4>No specific books currently requested by this school</h4>`;
      }
      data.forEach(product => {
        const template = this.template.content.cloneNode(true);
        template.querySelector('.title').innerText = product.title;
        template.querySelector('img').src = product.imageUrl ? product?.imageUrl : '';
        if (parseInt(product.quantity) > 0) {
          template.querySelector('.quantity').innerText = product.quantity;
        }
        else {
          template.querySelector('.qty--wrapper').style.display = 'none';
        }
        template.querySelector('.purchased').innerText = product.purchased;
        const atc = template.querySelector('button');
        atc.dataset.product_id = product.productId;
        if (product.variants.length === 1) {
          template.querySelector('.price').innerText = `£${product.variants[0].price}`;
          atc.dataset.variant_id = product.variants[0].legacyResourceId;
        }
        else {
          template.querySelector('.price--text').style.display = 'none';
          const selectTemplate = this.selectTemplate.content.cloneNode(true);
          const selectElement = selectTemplate.querySelector('select');
          selectElement.dataset.forProduct = product.productId;
          product.variants.forEach(variant => {
            const option = document.createElement('option');
            option.value = variant.legacyResourceId;
            option.innerText = `£${variant.price}`;
            selectElement.appendChild(option);
          });
          template.querySelector('.price').appendChild(selectTemplate);
        }
        atc.addEventListener('click', this.handleAddBook);
        this.results.appendChild(template);
      });
      this.loader.style.display = 'none';
    }).catch((error) => {
      this.results.textContent = error;
      this.loader.style.display = 'none';
    });
  };

  handleAddBook = (evt) => {
    try{
      this.addBook(evt);
    }catch(e){
      throwToast(e, 'error');
    }
  };

  addBook = (evt) => {
    evt.preventDefault();

      let variantId;

      const productId = evt.target.dataset.product_id;
      if (!!this.querySelector(`select[data-for-product="${productId}"]`)) {
        const valueSelector = this.querySelector(`select[data-for-product="${productId}"]`);
        if (valueSelector.value === '') {
          throw new Error('Select a value first')
        }
        else{
          variantId = valueSelector.value;
        }
      }else{
        variantId = evt.target.dataset.variant_id;
      }
      const qty = 1;
      fetch('/cart/add.js', {
        method: 'POST',
        cache: 'no-cache',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({
          items: [
            {
              'id': variantId,
              'quantity': qty,
              'properties': {
                '__schoolId': this.select.value,
                'School Name': this.select.options[this.select.selectedIndex].innerText,
              },
            },
          ],
        }),
      }).then((response) => response.text()).then((data) => {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
          bubbles: true,
        }));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      });


  };

}

customElements.define('school-books', SchoolBooks);
